module.exports = __webpack_public_path__ + "img/duration.a884971e.svg";